<template>
  <nav class="stepper" aria-label="Progress">
    <ol class="stepper__list">
      <li
        v-for="(label, idx) in steps"
        :key="getStepKey(label, idx)"
        class="stepper__item"
      >
        <div
          :class="[
            'stepper__circle',
            { 'stepper__circle--active': isCurrent(idx) }
          ]"
          :aria-current="isCurrent(idx) ? 'step' : null"
        >
          {{ idx + 1 }}
        </div>
        <div
          :class="[
            'stepper__label',
            { 'stepper__label--active': isCurrent(idx) }
          ]"
        >
          {{ label }}
        </div>
        <div
          v-if="idx < steps.length - 1"
          class="stepper__connector"
          aria-hidden="true"
        ></div>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'SignupStepper',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      required: true
    }
  },
  methods: {
    isCurrent(idx) {
      return this.currentStep === idx + 1;
    },
    getStepKey(label, idx) {
      return typeof label === "string" ? `${idx}-${label}` : idx;
    }
  }
}
</script>
